import { render, staticRenderFns } from "./trainingModulePageNew5.vue?vue&type=template&id=2bcdea74&scoped=true&"
import script from "./trainingModulePageNew5.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageNew5.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageNew5.vue?vue&type=style&index=0&id=2bcdea74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcdea74",
  null
  
)

export default component.exports